export { default } from './SearchResultContainer';
